import { getUserLang } from '@mb/lib/i18n';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { config } from '../../config';
import { Launch } from '../../redux/sliceCreators/launchesSlice';
import { client } from '../http';

interface CustomError {
  message: string;
}

interface FetchLaunchesResponse {
  status: string;
  campaigns: Launch[];
}

export const getLaucnhesThunk = createAsyncThunk<
  Launch[],
  void,
  { rejectValue: CustomError }
>('launches/get', async (_, thunkApi) => {
  try {
    const langPrefix = ENVIRONMENT_REGION === 'EU' ? `/${getUserLang()}` : '';

    const response = await client.get<FetchLaunchesResponse>(
      langPrefix + config.endpoints.fetchLaunches,
    );

    if (!response || response.data.status !== 'success') {
      return thunkApi.rejectWithValue({
        message: 'Failed to fetch launches data.',
      });
    }

    const campaigns = response.data.campaigns;
    return campaigns;
  } catch (e: any) {
    const message =
      e.response?.data?.message ?? 'Failed to fetch launches data.';
    return thunkApi.rejectWithValue({ message });
  }
});
